module.exports = __webpack_public_path__ + "static/ondemand team-d3e9c72660452d9f7ca364c6e3eb93da.svg";